{
  "el": {
    "lead": {
      "actions": {
        "add_company": "Προσθήκη εταιρείας",
        "add_lead": "Προσθήκη lead",
        "new": "Lead"
      },
      "attributes": {
        "address": "Διεύθυνση",
        "birth_date": "Ημερομηνία γέννησης",
        "categories": {
          "enduser": "Ιδιοχρήστης",
          "investor": "Επενδυτής"
        },
        "category": "Τύπος Lead",
        "company_name": "Όνομα εταιρείας",
        "company_vat": "Αριθμός ΦΠΑ",
        "email_address": "Email",
        "first_name": "Όνομα",
        "iban": "IBAN",
        "internal_note": "Εσωτερική σημείωση",
        "language": "Γλώσσα",
        "last_name": "Επώνυμο",
        "phone_landline": "Αριθμός σταθερού τηλεφώνου",
        "phone_mobile": "Αριθμός κινητού τηλεφώνου",
        "status": "Κατάσταση"
      },
      "labels": {
        "detailed_information": "Συμπλήρωσε αναλυτικές πληροφορίες",
        "lead": "Lead"
      },
      "validation": {
        "needFirstName": "Το όνομα είναι υποχρεωτικό",
        "needLastName": "Το επώνυμο είναι υποχρεωτικό"
      }
    }
  }
}
